export default __webpack_public_path__ + "static/media/buy-blue.c5c4f01c.svg";